import farmer from "@assets/intro-image.jpg";
import CustomImage from "@components/custom-image";
import { View } from "dripsy";
import * as React from "react";
import useCustomWindowDimensions from "@hooks/use-custom-window-dimensions";

export default function AuthImage() {
  const width = 4724;
  const height = 3149;
  const aspectRatio = width / height;
  const dimensions = useCustomWindowDimensions();
  const imageHeight = dimensions.width / aspectRatio;

  return (
    <View
      sx={{
        position: "absolute",
        top: 0,
        zIndex: -1,
        left: 0,
        right: 0,
        bottom: 0,
        alignItems: "center",
        justifyContent: "flex-end",
        overflow: "hidden",
      }}
    >
      <CustomImage
        source={farmer}
        sx={{ width: dimensions.width, height: imageHeight }}
        contentFit="contain"
        alt="Biologische supermarkt"
      />
    </View>
  );
}
